import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormRhombus"><Path d="M19.6602 12L11.998 23.0674L4.33594 12L11.998 0.932617L19.6602 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormRhombus;
